import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.group.id.sub');
import { OnInit, Input, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-group-id-sub',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.group.id.sub/view.scss */
/* src/app/page.group.id.sub/view.scss: no such file or directory */`],
})
export class PageGroupIdSubComponent implements OnInit, DoCheck {

    public id: any = '';
    public sub: any = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        this.id = WizRoute.segment.id;
        this.sub = WizRoute.segment.sub;
        await this.service.render();
    }

    public async ngDoCheck() {
        this.id = WizRoute.segment.id;
        this.sub = WizRoute.segment.sub;
    }
}

export default PageGroupIdSubComponent;